module.exports = __webpack_public_path__ + "media/images/down_arrow-d79d02aebd83505365d79408bbe37b7b.png";